import React, { useState, Component } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Phone, Mail, Send } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [smsConsent, setSmsConsent] = useState(false);
  const [marketingConsent, setMarketingConsent] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const subject = `Contact Form Inquiry from ${formData.name}`;
    const body = `Name: ${formData.name}
Email: ${formData.email}
Phone: ${formData.phone}

Message:
${formData.message}

---
Consent Preferences:
SMS/Text Consent: ${smsConsent ? 'Yes' : 'No'}
Marketing Communications Consent: ${marketingConsent ? 'Yes' : 'No'}`;
    const mailtoLink = `mailto:ravenadvisorsllc@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
  };
  return <div className="min-h-screen w-full bg-white selection:bg-slate-600 selection:text-white pt-20" data-id="element-175">
      <Header data-id="element-176" />

      <section className="relative py-20 px-6 lg:px-8 bg-white overflow-hidden" data-id="element-177">
        {/* Geometric Background */}
        <div className="absolute top-0 right-0 w-1/2 h-full bg-gray-50 -skew-x-12 transform translate-x-1/4" data-id="element-178" />
        <div className="absolute bottom-0 left-0 w-64 h-64 border-4 border-slate-600 transform rotate-45 -translate-x-1/2 translate-y-1/2 opacity-20" data-id="element-179" />

        <div className="max-w-7xl mx-auto w-full relative z-10" data-id="element-180">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start" data-id="element-181">
            {/* Left Column: Info */}
            <div data-id="element-182">
              <div className="mb-6 inline-block bg-slate-600 px-4 py-1 transform -skew-x-12" data-id="element-183">
                <span className="block transform skew-x-12 font-bold tracking-wider uppercase text-sm text-white" data-id="element-184">
                  Contact Us
                </span>
              </div>

              <h1 className="text-5xl md:text-7xl font-black tracking-tighter text-black mb-8 leading-none" data-id="element-185">
                LET'S <br data-id="element-186" />
                <span className="text-slate-600" data-id="element-187">CONNECT</span>.
              </h1>

              <p className="text-xl text-gray-700 font-medium mb-12 max-w-md" data-id="element-188">
                Ready to sell or have questions? Reach out to our team directly.
                We're here to help.
              </p>

              <div className="space-y-6" data-id="element-189">
                <a href="tel:630-686-7233" className="flex items-center gap-6 group p-6 bg-white border border-gray-200 hover:border-slate-600 hover:shadow-lg transition-all duration-300" data-id="element-190">
                  <div className="w-16 h-16 bg-slate-600 flex items-center justify-center text-white shrink-0" data-id="element-191">
                    <Phone className="w-8 h-8" data-id="element-192" />
                  </div>
                  <div data-id="element-193">
                    <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-1" data-id="element-194">
                      Call Us Anytime
                    </p>
                    <p className="text-2xl md:text-3xl font-black text-black group-hover:text-slate-600 transition-colors" data-id="element-195">
                      630-686-7233
                    </p>
                  </div>
                </a>

                <a href="mailto:ravenadvisorsllc@gmail.com" className="flex items-center gap-6 group p-6 bg-white border border-gray-200 hover:border-slate-600 hover:shadow-lg transition-all duration-300" data-id="element-196">
                  <div className="w-16 h-16 bg-black flex items-center justify-center text-white shrink-0" data-id="element-197">
                    <Mail className="w-8 h-8" data-id="element-198" />
                  </div>
                  <div data-id="element-199">
                    <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-1" data-id="element-200">
                      Email Us
                    </p>
                    <p className="text-xl md:text-2xl font-black text-black group-hover:text-slate-600 transition-colors break-all" data-id="element-201">
                      ravenadvisorsllc@gmail.com
                    </p>
                  </div>
                </a>
              </div>
            </div>

            {/* Right Column: Contact Form */}
            <div className="bg-gray-50 p-8 md:p-10 relative" data-id="element-202">
              <div className="absolute -top-3 -left-3 w-16 h-16 border-t-4 border-l-4 border-slate-600" data-id="element-203" />
              <div className="absolute -bottom-3 -right-3 w-16 h-16 border-b-4 border-r-4 border-slate-600" data-id="element-204" />

              {/* Business Name */}
              <p className="text-sm font-bold text-slate-600 uppercase tracking-wider mb-2" data-id="element-205">
                Raven Advisors LLC
              </p>

              <h2 className="text-2xl font-black text-black uppercase tracking-tight mb-2" data-id="element-206">
                Send Us a Message
              </h2>
              <p className="text-gray-600 mb-8" data-id="element-207">
                Fill out the form below and we'll get back to you as soon as
                possible.
              </p>

              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-208">
                <div data-id="element-209">
                  <label htmlFor="name" className="block text-black font-bold uppercase tracking-wider mb-2 text-sm" data-id="element-210">
                    Full Name <span className="text-red-500" data-id="element-211">*</span>
                  </label>
                  <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className="w-full bg-white text-black p-4 font-medium border border-gray-200 focus:outline-none focus:ring-4 focus:ring-slate-600/20 focus:border-slate-600" placeholder="John Doe" data-id="element-212" />
                </div>

                <div data-id="element-213">
                  <label htmlFor="email" className="block text-black font-bold uppercase tracking-wider mb-2 text-sm" data-id="element-214">
                    Email Address <span className="text-red-500" data-id="element-215">*</span>
                  </label>
                  <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full bg-white text-black p-4 font-medium border border-gray-200 focus:outline-none focus:ring-4 focus:ring-slate-600/20 focus:border-slate-600" placeholder="john@example.com" data-id="element-216" />
                </div>

                <div data-id="element-217">
                  <label htmlFor="phone" className="block text-black font-bold uppercase tracking-wider mb-2 text-sm" data-id="element-218">
                    Phone Number
                  </label>
                  <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full bg-white text-black p-4 font-medium border border-gray-200 focus:outline-none focus:ring-4 focus:ring-slate-600/20 focus:border-slate-600" placeholder="(555) 123-4567" data-id="element-219" />
                </div>

                <div data-id="element-220">
                  <label htmlFor="message" className="block text-black font-bold uppercase tracking-wider mb-2 text-sm" data-id="element-221">
                    Message <span className="text-red-500" data-id="element-222">*</span>
                  </label>
                  <textarea id="message" name="message" required rows={4} value={formData.message} onChange={handleChange} className="w-full bg-white text-black p-4 font-medium border border-gray-200 focus:outline-none focus:ring-4 focus:ring-slate-600/20 focus:border-slate-600 resize-none" placeholder="Tell us about your property or ask us a question..." data-id="element-223" />
                </div>

                {/* Consent Checkboxes - Not Mandatory */}
                <div className="space-y-4 pt-4 border-t border-gray-200" data-id="element-224">
                  <p className="text-xs text-gray-500 uppercase tracking-wider font-bold" data-id="element-225">
                    Communication Preferences (Optional)
                  </p>

                  <label className="flex items-start gap-3 cursor-pointer group" data-id="element-226">
                    <input type="checkbox" checked={smsConsent} onChange={e => setSmsConsent(e.target.checked)} className="mt-1 w-5 h-5 rounded border-gray-300 text-slate-600 focus:ring-slate-600" data-id="element-227" />
                    <span className="text-sm text-gray-700 leading-relaxed" data-id="element-228">
                      I consent to receive SMS/text messages from Raven Advisors
                      LLC regarding my inquiry and property-related updates.
                      Message frequency varies. Reply STOP to opt out at any
                      time.
                    </span>
                  </label>

                  <label className="flex items-start gap-3 cursor-pointer group" data-id="element-229">
                    <input type="checkbox" checked={marketingConsent} onChange={e => setMarketingConsent(e.target.checked)} className="mt-1 w-5 h-5 rounded border-gray-300 text-slate-600 focus:ring-slate-600" data-id="element-230" />
                    <span className="text-sm text-gray-700 leading-relaxed" data-id="element-231">
                      I consent to receive marketing communications and
                      promotional offers from Raven Advisors LLC via email
                      and/or phone.
                    </span>
                  </label>
                </div>

                {/* Disclosures */}
                <div className="bg-white p-4 border border-gray-200 space-y-3" data-id="element-232">
                  <p className="text-xs text-gray-600 leading-relaxed" data-id="element-233">
                    <strong data-id="element-234">Message Types:</strong> By providing your phone
                    number, you may receive transactional messages related to
                    your inquiry, appointment reminders, and property updates.
                  </p>
                  <p className="text-xs text-gray-600 leading-relaxed" data-id="element-235">
                    <strong data-id="element-236">Message Frequency:</strong> Message frequency varies
                    based on your inquiry and interaction with our services.
                  </p>
                  <p className="text-xs text-gray-600 leading-relaxed" data-id="element-237">
                    <strong data-id="element-238">Message & Data Rates:</strong> Standard message and
                    data rates may apply. Check with your mobile carrier for
                    details.
                  </p>
                  <p className="text-xs text-gray-600 leading-relaxed" data-id="element-239">
                    <strong data-id="element-240">Opt-Out:</strong> You can opt out of SMS messages at
                    any time by replying STOP to any message. You can opt out of
                    email communications by clicking the unsubscribe link in any
                    email.
                  </p>
                </div>

                {/* Legal Links */}
                <p className="text-xs text-gray-500 leading-relaxed" data-id="element-241">
                  By submitting this form, you acknowledge that you have read
                  and agree to our{' '}
                  <Link to="/privacy" className="text-slate-600 underline hover:text-black" data-id="element-242">
                    Privacy Policy
                  </Link>{' '}
                  and{' '}
                  <Link to="/terms" className="text-slate-600 underline hover:text-black" data-id="element-243">
                    Terms of Service
                  </Link>
                  .
                </p>

                <button type="submit" className="w-full bg-slate-600 text-white font-black uppercase tracking-widest py-5 text-lg hover:bg-black transition-colors flex items-center justify-center gap-3 group" data-id="element-244">
                  SEND MESSAGE
                  <Send className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-245" />
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      <Footer data-id="element-246" />
    </div>;
}